// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"eddbb0e8","273":"0e1ae239","346":"b6d6bc0e","556":"7d9cd163","651":"e382bece","799":"d75bf3f6","890":"3c08096a"}[chunkId] + ".chunk.js";
};